module.exports = __webpack_public_path__ + "img/borderLeftArrowWhite.f709e1d5.svg";